'use client';
import React, { useEffect, useState } from 'react';
import { Statistics } from '@bufdir/statistics-pages-components';
import { toStatisticspageProps } from '../utils';

type Props = {
  data: any;
};

const PagePage: React.FC<Props> = ({ data }) => {
  const [hash, setHash] = useState('');

  useEffect(() => {
    setHash(window.location.hash);
  }, []);

  const origin = new URL(process.env.NEXT_PUBLIC_STATS_STRAPI_URL as string)
    .origin;
  const pageProps = toStatisticspageProps(data.data[0], origin);

  return <Statistics {...pageProps} hash={hash} />;
};

export default PagePage;
